import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppShell from './components/AppShell';
import AIAssistant from './components/AIAssistant';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import Restaurants from './pages/Restaurants';
import Spaces from './pages/Spaces';
import Outreach from './pages/Outreach';
import IntelligenceHub from './pages/IntelligenceHub';
import AutomationHub from './pages/AutomationHub';
import AIAgent from './pages/AIAgent';
import News from './pages/News';
import ContentScheduler from './pages/ContentScheduler';
import CapitalHub from './pages/CapitalHub';
import InstagramIntel from './pages/InstagramIntel';
import ContactEnrichment from './pages/ContactEnrichment';
import HamptonsMap from './pages/HamptonsMap';
import Settings from './pages/Settings';
import { Toaster } from './components/ui/sonner';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
};

const AppContent = () => {
  const { user } = useAuth();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/*" element={
          <ProtectedRoute>
            <div className="app-shell">
              <AppShell>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/contacts" element={<Contacts />} />
                  <Route path="/restaurants" element={<Restaurants />} />
                  <Route path="/spaces" element={<Spaces />} />
                  <Route path="/outreach" element={<Outreach />} />
                  <Route path="/intelligence" element={<IntelligenceHub />} />
                  <Route path="/automation" element={<AutomationHub />} />
                  <Route path="/agent" element={<AIAgent />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/content" element={<ContentScheduler />} />
                  <Route path="/capital" element={<CapitalHub />} />
                  <Route path="/instagram-intel" element={<InstagramIntel />} />
                  <Route path="/enrichment" element={<ContactEnrichment />} />
                  <Route path="/map" element={<HamptonsMap />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </AppShell>
              <AIAssistant />
            </div>
          </ProtectedRoute>
        } />
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
};

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
